<template>
    <div class="wrap" ref="wrap" :style="wrapStyle">
        <div class="options" tabindex=":tabindex" role="menu" ref="pane" @keydown="doKeydown"
                :aria-label="$t(`${panename}.ariaName`)">
            <slot>nothing</slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'DropPane',
  components: { },
  data: function() {
    return {
      wrapStyle: {}
    };
  },
  props: {
    panename: {
      type: String,
      required: true
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    console.log('mounted');
    this.$nextTick(() => {
      if (this.tabindex !== -1) {
        this.$refs.pane.focus();
      } else {
        var focusable = this.$refs.pane.querySelector('*[tabindex="0"]');
        if (focusable) {
          focusable.focus();
        }
      }
    });
    const wrap = this.$refs.wrap;
    const rect = wrap.getBoundingClientRect();
    if ((rect.x + wrap.clientWidth + 50) > window.innerWidth) {
      this.wrapStyle = {
        left: (window.innerWidth - (rect.x + wrap.clientWidth + 50)) + 'px'
      };
    }
  },
  methods: {
    doKeydown(evt) {
      if (evt.key === 'Escape') {
        this.$emit('escape');
        this.$emit('hide');
      }
    }
  },
  computed: {
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';
    .wrap {
        display: inline-block;
        z-index: 100;
        position: absolute;
        top: 20px;
        left: 0px;
        background-color: white;
        color: $black;
        box-shadow: 0px 0px 5px 3px $gray-200;
        max-height: 50vh;
        min-height: 1em;
        max-width: 50vw;
        padding: 0;
        display: flex;
        flex-direction: column;

        .options {
            flex: 1;
            overflow-y: auto;
            overflow-x: auto;
        }
    }

</style>
